import axios from "axios";
import AuthHelper from "components/auth/helpers";
import { APP_API_ENDPOINT } from "config/endpoints";
import { common } from "utils/Wording";
import { showErrorNotification } from "utils/hooks/handleNotification";
import { ApiURL } from "./utils/Actions";
import moment from "moment";
const api = axios.create({ baseURL: APP_API_ENDPOINT });
export const loginApi = axios.create({ baseURL: APP_API_ENDPOINT });
let refreshInProgress = false;

api.interceptors.request.use(
  async config => {
    const token = AuthHelper.getAuth()?.accessToken;
    if (token) {
      const strAccessTokenExpireTime =
        localStorage.getItem(AuthHelper.TOKEN_EXPIRE_TIME) ||
        moment().subtract(1, "seconds").format();
      const accessTokenExpireTime = moment(strAccessTokenExpireTime);
      if (accessTokenExpireTime.isAfter(moment())) {
        // it's not pass timeout now, so go ahead for API call
        config.headers["Authorization"] = token ? `Bearer ${token}` : "";
      } else {
        if (
          config.url != ApiURL.refreshToken &&
          config.url != ApiURL.appStatus &&
          !refreshInProgress
        ) {
          // To invoke refreshToken only when (1) this request is NOT refreshToken (2) this is not app-status which is IT heartbeat (3) Not refresh in progress
          const refreshPayload = {
            grant_type: "refresh_token",
            refresh_token: AuthHelper.getRefreshToken()
          };
          refreshInProgress = true;
          AuthHelper.toggleRefreshTokenWIP(true);

          // firstly to call *refreshToken*
          await api
            .post(ApiURL.refreshToken, refreshPayload)
            .then(res => {
              if (res.data) {
                const existingAuth = AuthHelper.getAuth();
                const timeout = res.data.expires_in || 0;
                const transformedData = {
                  ...existingAuth,
                  expireTime: moment().add(timeout, "seconds"),
                  accessToken: res.data.access_token,
                  refreshToken: res.data.refresh_token
                };
                AuthHelper.setAuth(transformedData);
                AuthHelper.extendTimeout(true);
                config.headers["Authorization"] = token ? `Bearer ${res.data.access_token}` : "";
              }
            })
            .then(() => {
              refreshInProgress = false;
              AuthHelper.toggleRefreshTokenWIP(false);
            })
            .catch(() => {
              // If error is unauthorised, clear auth data
              showErrorNotification({ message: common.authError });
              AuthHelper.clearAuth();
              refreshInProgress = false;
              // dispatch(setShouldRefreshRunning(false))
              AuthHelper.toggleRefreshTokenWIP(false);
            });
        }
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => {
    AuthHelper.extendTimeout(false);
    return response;
  },
  error => {
    if (error.response) {
      const { status } = error.response;
      if (status === 400) {
        showErrorNotification({ message: common.badRequestError, checkInApp: true });
      } else if (status === 403) {
        showErrorNotification({ message: common.authError, checkInApp: true });
        AuthHelper.clearAuth();
      } else if (status === 401) {
        // If error is unauthorised, clear auth data
        // if this particular endpoint, do not attempt to call refreshToken
        const { url } = error.config;
        const endpointName = url.split("?")[0];
        if (endpointName === ApiURL.updatePasswordToken) {
          return error;
        }
        const refreshPayload = {
          grant_type: "refresh_token",
          refresh_token: AuthHelper.getRefreshToken()
        };
        //firstly to call *refreshToken*
        api
          .post(ApiURL.refreshToken, refreshPayload)
          .then(res => {
            if (res?.data && res?.status === 200) {
              console.log("===>Token refreshed @ " + new Date());
              const existingAuth = AuthHelper.getAuth();
              const timeout = res.data.expires_in || 0;
              const transformedData = {
                ...existingAuth,
                expireTime: moment().add(timeout, "seconds"),
                accessToken: res.data.access_token,
                refreshToken: res.data.refresh_token
              };
              AuthHelper.setAuth(transformedData);
            } else {
              showErrorNotification({ message: common.refreshTokenAlert });
            }
          })
          .catch(() => {
            // If error is unauthorised, clear auth data
            showErrorNotification({ message: common.authError });
            AuthHelper.clearAuth();
          });
      } else if (status === 500) {
        showErrorNotification({ message: common.serverError });
      }
      if (error.response.data) {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }
);

export default api;
